<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container" >
            <v-card flat>
                <v-card-title class="headline">
                    Eigene Mitarbeitergespräche
                </v-card-title>

                <v-card-text>
                    Übersicht zu allen Gesprächen, die Ihre Führungskraft mit Ihnen geführt hat.
                </v-card-text>
            </v-card>

            <v-card class="mt-4">
                <v-card-title>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Suchen"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <EmployeeInterviewsUtilityInterviewsDataTable :headers="headers" :search="search" :items="interviews" type="interviewed">
                    <!--Customizing default rows-->
                </EmployeeInterviewsUtilityInterviewsDataTable>
            </v-card>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            search: '',
            headers: [
                {
                    text: 'Datum',
                    align: 'start',
                    value: 'date_interview'
                },
                { text: 'Durchführende Person', value: 'processing_person'},
                { value: 'action'},
            ],

            interviews: [],
        }),
        created() {
            this.get();
        },
        methods: {
            get(){
                this.axios.get('/interviews?type=interviewed').then( (response) => {
                    this.interviews = Object.values({...response.data.data.interviews});
                });
            },
        }

    }
</script>

<style scoped>

</style>